import { render, staticRenderFns } from "./JM2408.vue?vue&type=template&id=19edb79a"
import script from "./JM2408.vue?vue&type=script&lang=js"
export * from "./JM2408.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports